import React, { useState } from 'react'
import CleverIcon from './../assets/clever-icon.svg';
import { clever_login_url } from './interfacesAndConstants';


const CleverLogin = () => {
  const [disabled, setDisabled] = useState<boolean>(false)

  const cleverOnClickHandler = () => {
    setDisabled(true)
    trackEventsForGuests("Interacted Login Method Selection Screen", { "mp_login_user_type": "student", "Clicked on": "Clever" }, { send_mixpanel: true })
    // [AI GENERATED CODE] — Set pending source before OAuth redirect so createSession picks it up on return.
    if (typeof (window as any).MUS !== 'undefined') (window as any).MUS.setPendingSource('clever');
    window.location.href = clever_login_url()
    setTimeout(() => setDisabled(false), 2000)
  }


  return (
    <button
      className={`clever-login${disabled ? " disabled": ""}`}
      onClick={cleverOnClickHandler}
      >
        <CleverIcon/>
        Clever
    </button>
  )
}

export default CleverLogin